import { FC } from "react";
import { createPortal } from "react-dom";
import { useConfig } from "./shared/hooks/useConfig";

export const Robots: FC = () => {
	const { productData } = useConfig();

	if (productData.enableSearchEngineIndexing) {
		return null;
	}

	return createPortal(<meta name="robots" content="noindex, nofollow" />, document.head);
};
